export const DISPUTE_SUGGESTED_ARTICLES_ID =
  "dispute_suggested_articles_d067141f-77b9-4aca-a1ad-1625b9d726f0";

export const PREDRAFT_EMAIL = "hello@predraft.ai";
